export enum LessonTemplateType {
  VIDEO = 'VIDEO',
  SQ4_TEXT_AUDIO_IMAGE = '4SQ text/audio+image',
  SQ4_IMAGE_TEXT_AUDIO = '4SQ image/text+audio',
  SQ4_IMAGE_AUDIO_TEXT = '4SQ image/audio+text',
  DND_IMAGE_TEXT = 'DND image+text',
  DND_TEXT_TEXT = 'DND text+text',
  DND_AUDIO_IMAGE = 'DND audio+image',
  DND_AUDIO_TEXT = 'DND audio+text',
  UNSCRAMBLE = 'UNSCRAMBLE',
  MC = 'MC',
  TIB = 'TIB',
  DIALOG = 'DIALOG',
  PRONOUNCE = 'PRONOUNCE',
  SCRIPTED_CONVERSATION = 'SCRIPTED CONVO',
}
